import { useEffect } from 'react';
// import loginIllustration from '../../assets/images/illustration-3837.png';
import loginIllustration from '../../assets/images/Login.png';
import logo from '../../assets/images/logo.png';

import { cx } from '@emotion/css';
import * as styles from './loginIntro.style';
import elementObserver from '../utils/shadowDomObserver';
import GoogleButton from 'react-google-button'
import { Auth } from 'aws-amplify';



export default function LoginIntro({ children, setElm }) {
  // useEffect(async () => {
  //   const authObserver = await elementObserver({ sel: '.auth-form-container' });
  //   const parentElm = await authObserver.promise;
  //   const shadowObserver = await elementObserver({
  //     context: parentElm.shadowRoot,
  //     sel: '.auth-container',
  //   });
  //   const shadowElm = await shadowObserver.promise;
  //   shadowElm.classList.remove('auth-container');

  //   setElm(shadowElm);

  //   return () => {
  //     authObserver.clearObserver();
  //     shadowObserver.clearObserver();
  //   };
  // }, []);

  useEffect(() => {
    async function fetchData() {
      const authObserver = await elementObserver({ sel: '.auth-form-container' });
      const parentElm = await authObserver.promise;
      const shadowObserver = await elementObserver({
        context: parentElm.shadowRoot,
        sel: '.auth-container',
      });
      const shadowElm = await shadowObserver.promise;
      shadowElm.classList.remove('auth-container');

      setElm(shadowElm);



      return () => {
        authObserver.clearObserver();
        shadowObserver.clearObserver();
      };
    }

    fetchData();
  }, []);


  useEffect(() => {
    document.querySelectorAll('.auth-form').forEach(async (item) => {
      const shadowObserver = elementObserver({
        context: item.shadowRoot,
        sel: '.section',
      });
      const shadowElm = await shadowObserver.promise;
      const elmSectionObserver = elementObserver({
        context: item.shadowRoot,
        sel: 'amplify-form-section',
      });
      const elms = await elmSectionObserver.promise;
      const styleSheet = document.createElement('style');

      styleSheet.innerHTML = styles.form;

      elms.appendChild(styleSheet);
      shadowElm.classList.remove('section');
    });
  }, []);

  return (
    <section className={cx(styles.container)}>
      <div className={cx(styles.leftPanel)}>
        <img src={loginIllustration} alt="" />
      </div>
      <div className={cx(styles.rightPanel)}>
        {/* <img className={cx(styles.logo)} src={logo} alt="" /> */}
        <div className={cx(styles.authContainer)}>
          {/* <h2 className={cx(styles.heading)}>Hey,</h2> */}
          <h3 className={cx(styles.subHeading)}>Let's get started</h3>

          <GoogleButton width="100" onClick={() => Auth.federatedSignIn({ provider: 'Google' })}>Sign in with Google</GoogleButton>
          <br></br>
          {children}

        </div>
      </div>
    </section>
  );
}
